import { render, staticRenderFns } from "./serveTab3.vue?vue&type=template&id=3642de4c&scoped=true"
import script from "./serveTab3.vue?vue&type=script&lang=js"
export * from "./serveTab3.vue?vue&type=script&lang=js"
import style0 from "./serveTab3.vue?vue&type=style&index=0&id=3642de4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3642de4c",
  null
  
)

export default component.exports